/**
 * PageHeader
 * ─────────────────────────────────────────────────────────────────────────────
 * The single, canonical page header used across every module.
 * Replaces HeaderWithBtn, CustomerTableHeader, and any ad-hoc header boxes.
 *
 * Props
 *   title          string           Page / section title (required)
 *   subtitle       node             Optional subtitle or date string below title
 *   children       node             Anything placed in the right-side action slot
 *   sx             object           Extra sx merged into the outer container
 *   titleSx        object           Extra sx merged into the <Typography> title
 *   actionsGap     number|string    Gap between action items (default 1.5)
 * ─────────────────────────────────────────────────────────────────────────────
 */
import { Box, Typography } from '@mui/material';
import { headerActionsSx, headerContainerSx, headerTitleSx } from './designSystem';

const PageHeader = ({
  title,
  subtitle,
  children,
  sx = {},
  titleSx = {},
  actionsGap = 1.5,
}) => {
  return (
    <Box sx={{ ...headerContainerSx, ...sx }}>
      {/* Left: title + optional subtitle */}
      <Box>
        <Typography variant="h2" component="h2" sx={{ fontWeight: 600, ...(titleSx || {}), ...headerTitleSx }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: '#797777ff', mt: 0.25, display: 'block' }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {/* Right: action slot */}
      {children && (
        <Box sx={{ ...headerActionsSx, gap: actionsGap }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default PageHeader;
